import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/education.css'; // Custom styles for the section
//import image1 from '../images/school.png';
//import image2 from '../images/inter.jpg';
import image3 from '../images/cukmain.png';
import image4 from '../images/iitkgpmain.jpeg';
import image5 from '../images/mit.jpeg';

const educationData = [
  {
    title: 'Quantum Computing Essentials Program MIT-XPro',
    enroll:"Currently Enrolled - Feb-2025",
    institution: 'Massachusetts Institute of Technology (MIT)',
    place:"USA",
    description: 'Quantum computing Essentials Program is a field that uses quantum mechanics to solve complex problems faster than classical computers. Its a multidisciplinary field that combines aspects of computer science, physics, and mathematics ',
    image: image5,
  },
  {
    title: 'Integrated Phd (M.Sc) ',
    institution: 'IIT Kharagpur ',
    place:"West Bengal - India",
    grade: 'Grade- A',
    description: 'Pursued Masters Program in Exploration Geophysics, gaining hands-on experience in geophysical exploration techniques and focusing on geophysical methods, data analysis, Energy Sector and Earth science.',
    image: image4,
  },
  {
    title: 'Integrated Msc (BSc-Honors)',
    institution: 'Central University of Karnataka, India',
    grade: 'Grade- A+',
    description: 'Integrated M.Sc(BSc) Honors Degree with Applied Geology & GeoInformatics,  Knowledge in the field of Mineralogy, Mining  industry & oil sector.',
    image: image3,
  },
  // {
  //   title: 'Higher Secondary (+2) in Mathematics, Physics, Chemistry',
  //   institution: 'Andhra Pradesh Open School Society, Hyderabad',
  //   description: 'Completed my Higher Secondary Education with majors in Mathematics, Physics, and Chemistry, building a strong foundation for my future academic endeavors.',
  //   image: image2,
  // },
  // {
  //   title: 'High School (10th Grade) with Distinction',
  //   institution: 'Gowtham IIT Talent High School, Madanapalle, Andhra Pradesh',
  //   description: 'Graduated from high school with a distinction, excelling in academics and laying the groundwork for my interest in science and technology.',
  //   image: image1,
  // },
];

const Education = () => {
  return (
    <section className="education-section py-5" id="education">
      <Container>
        <h2 className="text-center text-dark  mb-4">Education Details</h2> <hr/>
        {educationData.map((edu, index) => (
          <Row className="my-5 education-row" key={index}>
            <Col lg={6} className={`order-lg-${index % 2 === 0 ? 1 : 2} mb-4`}>
              <div className="education-info">
                <h3>{edu.title}</h3>
                <h4 className="text-primary fw-bold" >{edu.institution}</h4>
                <h6>{edu.enroll }</h6>
                <h5>{edu.place}</h5>
                <h5 className="fw-bold text-dark " >{edu.grade }</h5>
                <p>{edu.description}</p>
              </div>
            </Col>
            <Col lg={6} className={`order-lg-${index % 2 === 0 ? 2 : 1}`}>
              <Image
                src={edu.image}
                alt={edu.institution}
                fluid
                className="education-image"
              />
            </Col>
          </Row>
        ))}
      </Container>
    </section>
  );
};

export default Education;
